import React from 'react'
import Header from './Header'
import Triangle from './Triangle'

const VcTrustFramework = () => {
    return (
        <div className='vc_container'>
            <Header />

            <Triangle/>
        </div>

    )
}

export default VcTrustFramework
